import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Logger } from '../../../../../infrastructure/logging/logger';
import { ReferenceService } from '../../../../../shared/reference/reference.service';
import { createDownloadAttachmentLink } from '../../../../../utilities/FileUtility';
import { ImageUtility } from '../../../../../utilities/ImageUtility';

export interface ClaimDocument {
  claim_id?: number;
  description?: string;
  file_id?: number;
  file_name?: string;
  id?: number;
}
interface ClaimDetailAttachmentDialogData {
  isImage: boolean;
  document: ClaimDocument;
}

@Component({
  selector: 'app-claim-detail-attachment-dialog',
  templateUrl: './claim-detail-attachment-dialog.component.html',
  styleUrls: ['./claim-detail-attachment-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatProgressSpinner, 
    MatIcon, 
    MatDialogModule,
    MatButtonModule
  ]
})
export class ClaimDetailAttachmentDialogComponent implements OnInit {

  loadingImage = false;
  loadingFailed = false;
  fileData: string | ArrayBuffer | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ClaimDetailAttachmentDialogData,
    private referenceService: ReferenceService,
    private imageUtility: ImageUtility,
    private logService: Logger
  ) { }

  ngOnInit(): void {
    this.loadingImage = true;
    this.retrieveFileData();
  }

  async retrieveFileData() {
    try {
      if (!this.data.document.file_id) {
        return;
      }

      let base64FileData = await this.referenceService.getFileDataById(this.data.document.file_id);
      if (this.data.isImage && this.imageUtility.isHeicFile(this.data.document.file_name)) {
        base64FileData.image = await this.imageUtility.heicToJpg(base64FileData.image);
      }

      const fileDataBlob = await this.imageUtility.getFileFromBlob(base64FileData.image);
      this.fileData = fileDataBlob;
    } catch (e) {
      this.loadingFailed = true;
      this.logService.handleError(e, 'An error occurred while retrieving attachment', `Error while downloading image to display. Image File ID: ${this.data.document.file_id}`);
    } finally {
      this.loadingImage = false;
    }
  }

  onDownloadClick() {
    try {
      if (this.data?.document?.file_id == null || this.data?.document?.file_name == null) {
        this.logService.handleError('Cannot download attachment. File ID or File Name is null.', 'Cannot download attachment', `Cannot download attachment. File ID or File Name is null.`);
        return;
      }

      createDownloadAttachmentLink(this.data.document.file_name, this.fileData);
    } catch (e) {
      this.loadingFailed = true;
      this.logService.handleError(`Error while downloading attachment. File ID: ${this.data.document.file_id}`, 'An error occurred while downloading attachment', `Error while downloading attachment. File ID: ${this.data.document.file_id}`);
    }
  }
}